import { Injectable, inject } from '@angular/core';

import { TODO } from '@b2b/types/core/utils';

import { FILTER_PORT, type IFilterPort } from '../utils/filter.port';

/**
 * AuditTrailColumnGenerator — Angular 18.
 *
 * Ported 1:1 from
 * apps/b2b-ui/common/services/auditTrail/auditTrailColumnGenerator/auditTrailColumnGenerator.service.js
 * (legacy AngularJS name 'AuditTrailColumnGenerator').
 *
 * Produces the ag-grid cell style/renderer callbacks used by the audit-trail
 * diff grids. `$filter('currency')` is bridged via FILTER_PORT.
 *
 * Registered back into AngularJS under 'AuditTrailColumnGenerator' via
 * downgradeInjectable in app/upgrade/ng-downgraded-components.ts.
 */
@Injectable({ providedIn: 'root' })
export class AuditTrailColumnGenerator {
  private $filter = inject<IFilterPort>(FILTER_PORT);

  /**
   * Determines style that a cell should take.
   */
  getCellStyle(): (params: TODO) => TODO {
    return function (params: TODO) {
      let style: TODO = {};
      const column = params.column.colId.toString();

      if (params.data['col' + [column]].op === 'replaced') {
        style['background-color'] = '#FADD66';
      } else if (params.data['col' + column].op === 'removed') {
        style['background-color'] = '#F9B8B7';
        style['text-decoration'] = 'line-through';
      } else {
        style = '';
      }

      return style;
    };
  }

  /**
   * Determines how the cell values should render.
   */
  getCellRenderer(): (params: TODO) => TODO {
    const $filter = this.$filter;
    return function (params: TODO) {
      const column = params.column.colId.toString();
      const format = params.data['col' + [column]].format;
      const value = params.data['col' + [column]].value;
      let res;
      switch (format) {
        case 'boolean':
          if (value === false) {
            res = 'No';
          } else if (value === true) {
            res = 'Yes';
          }
          break;
        case 'currency':
          res = $filter('currency')(value);
          break;
        case 'percent':
          res = Number(value) + '%';
          break;
        case 'value':
          res = Number(value).toString();
          break;
        default:
          res = value;
      }
      return res;
    };
  }
}
